import { locationFinderDealerDisplayStyles } from "@insite/content-library/Widgets/LocationFinder/LocationFinderDealerDisplay";
import { css } from "styled-components";

locationFinderDealerDisplayStyles.container = {
    gap: 10,
    css: css`
        background: transparent;
    `,
};

locationFinderDealerDisplayStyles.googleMapsDirectionLinkGridItem = {
    width: [6, 3, 3, 3, 3],
};

locationFinderDealerDisplayStyles.visitWebsiteLinkGridItem = {
    width: [6, 3, 3, 3, 3],
};
